<template>
    <v-container>
        <!-- Application Header -->
        <div v-if="step == 'apply'">
            <h1>טופס בקשה לקרן סיוע הדדי – הסתדרות העובדים החדשה</h1>
            <strong class="small-label"><p><small class="asterik">*</small> לתשומת הלב: מטרת קרן הסיוע לסייע לזכאים במוצרים
                ומצרכים אך לא
                בהלוואות או מענקים
                כספיים</p></strong>
        </div>
        <!-- Other Header -->
        <div v-else>
            <v-col cols="12" sm="2" offset="5">
                <img text-center src="../assets/Hlogo.png">
                <v-divider/>
            </v-col>
        </div>
        <!-- Identity Form -->
        <v-form
            v-if="step=='identify'"
            v-model="smsStatus"
            method="post"
            @submit.prevent="checkSMS"
            ref="formsms"
        >
            <v-row>
                <v-col cols="12" sm="4" offset="0" offset-sm="4">
                    <h2 class="text-center" v-if="formType == 1">הגשת טופס בקשה לקרן סיוע</h2>
                    <h2 class="text-center" v-if="formType == 2">הגשת טופס בקשה לקרן סיוע שורדי שואה</h2>
                    <p class="text-center">
                        לפני מילוי הטופס, יש לבצע הזדהות.
                        ההזדהות היא עם פרטיך האישיים.
                        מיד לאחר לחיצה על כפתור "שלח לי קוד אימות"
                        ישלח קוד אימות זמני לאימות לטלפון הנייד שלך או למייל.
                    </p>
                    <v-row>

                        <v-col cols="12" md="12">
                            <p class="text-center">
                                הזדהות לפי:
                            </p>
                            <v-radio-group
                                name="identifyBy"
                                :rules="[rules.requiredRule]"
                                v-model="identifyBy"
                                class="vertical-radio"
                            >
                                <v-radio value="id">
                                    <template v-slot:label>
                                        <div>
                                            תעודת זהות
                                        </div>
                                    </template>
                                </v-radio>
                                <v-radio value="passport">
                                    <template v-slot:label>
                                        דרכון
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- ID -->
                        <v-col cols="12 minus-top" v-if="identifyBy == 'id'">
                            <v-text-field
                                label="מספר ת.ז."
                                class="required"
                                required
                                v-model.trim="id"
                                name="id"
                                type="text"
                                :rules="[rules.ID]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!-- Passport -->
                        <v-col cols="12 minus-top" v-if="identifyBy == 'passport'">
                            <v-text-field
                                label="מספר דרכון"
                                class="required"
                                required
                                v-model.trim="passport"
                                name="passport"
                                type="text"
                                :rules="[rules.passport]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="12">
                            <p class="text-center">
                                שליחת קוד אימות:
                            </p>
                            <v-radio-group
                                name="verifyCodeTo"
                                :rules="[rules.requiredRule]"
                                v-model="verifyCodeTo"
                                class="vertical-radio"
                            >
                                <v-radio value="mobile">
                                    <template v-slot:label>
                                        לטלפון נייד
                                    </template>
                                </v-radio>
                                <v-radio value="email">
                                    <template v-slot:label>
                                        למייל
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- Tel -->
                        <v-col cols="12 minus-top" v-if="verifyCodeTo == 'mobile'">
                            <v-text-field
                                label="טלפון נייד"
                                class="required"
                                required
                                v-model.trim="tel"
                                name="tel"
                                type="tel"
                                :rules="[rules.tel]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!-- Email -->
                        <v-col cols="12 minus-top" v-if="verifyCodeTo == 'email'">
                            <v-text-field
                                label="כתובת מייל"
                                class="required"
                                required
                                v-model.trim="email"
                                name="email"
                                type="email"
                                :rules="[rules.email]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="text-center">
                            <v-btn
                                :loading="loading"
                                class="mt-3 mb-10"
                                type="submit"
                                color="primary"
                                large
                            >שלח לי קוד אימות
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
        <!-- Authentication Form -->
        <v-form
            v-if="step=='auth'"
            method="post"
            @submit.prevent="authenticate"
            ref="formauth"
        >
            <v-row>
                <v-col cols="12" sm="4" offset="0" offset-sm="4">
                    <h2 class="text-center">הגשת טופס בקשה</h2>
                    <p class="text-center">
                        הכנס/י את קוד האימות שנשלח אליך לנייד/אימייל
                    </p>
                    <v-row>

                        <v-col cols="12">
                            <v-text-field
                                label="קוד אימות"
                                class="required"
                                required
                                v-model.trim="authCode"
                                name="authCode"
                                type="text"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>
                        <p class="text-center text-red text-small" v-if="auth === 'error'">קוד האימות שהוזן לא תואם את קוד האימות
                            שנשלח</p><br/>
                        <p class="text-center"><a href="#" @click="resend">שלחו לי קוד אימות חדש</a></p>
                        <v-col cols="12" class="text-center">
                            <v-btn
                                :loading="loading"
                                class="mt-3 mb-10"
                                type="submit"
                                color="primary"
                                large
                            >פתיחת טופס
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
        <!-- Application Form -->
        <v-form
            v-if="step == 'apply'"
            v-model="fieldsStatus"
            method="post"
            @submit.prevent="submit"
            ref="formapp"
        >
            <v-row>
                <v-col class="col-sm-8 col-12 star-notice">
                    <p class="text-medium text-red text-center text-large">* שדות המסומנים בכוכבית הינם שדות חובה</p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h2 class="mt-10">פרטים אישיים</h2>
                    <!-- Personal Details -->

                    <v-row>
                        <!-- ID -->
                        <v-col cols="12" sm="6" md="4" v-if="identifyBy == 'id'">
                            <v-text-field
                                label="מספר ת.ז."
                                class="required"
                                required
                                v-model.trim="id"
                                name="id"
                                type="text"
                                :rules="[rules.ID]"
                                :outlined="outlined"
                                disabled
                            ></v-text-field>
                        </v-col>

                        <!-- Passport -->
                        <v-col cols="12" sm="6" md="4" v-if="identifyBy == 'passport'">
                            <v-text-field
                                label="מספר דרכון"
                                class="required"
                                required
                                v-model.trim="passport"
                                name="passport"
                                type="text"
                                :outlined="outlined"
                                disabled
                            ></v-text-field>
                        </v-col>

                        <!-- Tel -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="טלפון נייד"
                                class="required"
                                required
                                v-model.trim="tel"
                                name="tel"
                                type="text"
                                :rules="[rules.tel]"
                                :outlined="outlined"
                                :disabled="verifyCodeTo === 'mobile'"
                            ></v-text-field>
                        </v-col>

                        <!-- Email -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="אימייל"
                                class="required"
                                required
                                v-model.trim="email"
                                name="email"
                                type="email"
                                :rules="[rules.emailRequired]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>
                        <!-- First Name -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="שם פרטי"
                                class="required"
                                name="firstName"
                                required
                                v-model.trim="firstName"
                                type="text"
                                :rules="[rules.minLength(2, 'יש להזין שם פרטי')]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!-- Last Name -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="שם משפחה"
                                class="required"
                                name="lastName"
                                required
                                v-model.trim="lastName"
                                type="text"
                                :rules="[rules.minLength(2, 'יש להזין שם משפחה')]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>
                        <!-- City -->
                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete
                                label="עיר מגורים"
                                autocomplete="none"
                                class="required"
                                required
                                v-model.trim="city"
                                name="city"
                                item-text="v"
                                item-value="k"
                                :items="cities"
                                :rules="[rules.minLength(1, 'יש לבחור עיר מגורים')]"
                                :loading="loadingCities"
                                :outlined="outlined"
                            ></v-autocomplete>
                        </v-col>
                        <!-- Street -->
                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete
                                autocomplete="none"
                                label="רחוב מגורים"
                                class="required"
                                required
                                v-model.trim="street"
                                name="street"
                                item-text="v"
                                item-value="k"
                                :items="streets"
                                :rules="[rules.minLength(1, 'יש לבחור רחוב מגורים')]"
                                :loading="loadingStreets"
                                :outlined="outlined"
                            ></v-autocomplete>
                        </v-col>

                        <!-- Home Number -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="מס' בית"
                                class="required"
                                required
                                v-model.trim="homeNum"
                                name="homeNum"
                                type="number"
                                :rules="[rules.minLength(1, 'יש להזין מספר בית'), rules.numbers]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!-- Apartment Entrance -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="כניסה"
                                v-model.trim="apartEntrance"
                                name="apartEntrance"
                                type="number"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!--House Type-->
                        <v-col class="house-type" cols="12">
                            <v-radio-group :row="true"
                                name="houseType"
                                class="house-type-radio-group"
                                v-model="houseType"
                                :outlined="outlined">
                                <p class="house-type-title">
                                    סוג בית
                                </p>
                                <v-radio value="sharedHouse" selsected>
                                    <template v-slot:label>
                                        <div>משותף</div>
                                    </template>
                                </v-radio>
                                <v-radio value="privetHouse">
                                    <template v-slot:label>
                                        <div>פרטי</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- Apartment Number -->
                        <v-col cols="12" sm="6" md="4" v-if="houseType === 'sharedHouse'">
                            <v-text-field
                                label="מס' דירה"
                                v-model.trim="apartNum"
                                name="apartNum"
                                type="number"
                                :outlined="outlined"
                                class="required"
                                required
                                :rules="[rules.requiredRule, rules.numbers]"
                            ></v-text-field>
                        </v-col>
                        <!-- Apartment Floor -->
                        <v-col cols="12" sm="6" md="4" v-if="houseType === 'sharedHouse'">
                            <v-text-field
                                label="קומה"
                                v-model.trim="apartFloor"
                                name="apartFloor"
                                type="number"
                                :outlined="outlined"
                                class="required"
                                required
                                :rules="[rules.requiredRule, rules.numbers]"
                            ></v-text-field>
                        </v-col>
                    </v-row>


                    <h2 class="mt-10" v-if="formType == '2'">פרטי גורם מסייע</h2>
                    <!-- Helper Details -->
                    <v-row v-if="formType == '2'">

                        <!-- Name -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="שם גורם מסייע"
                                name="helperName"
                                v-model.trim="helperName"
                                type="text"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!-- Tel -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="טלפון"
                                v-model.trim="helperPhone"
                                name="helperPhone"
                                type="text"
                                :rules="[rules.tel]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>

                        <!-- Email -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                label="אימייל"
                                v-model.trim="helperEmail"
                                name="helperEmail"
                                type="email"
                                :rules="[rules.email]"
                                :outlined="outlined"
                            ></v-text-field>
                        </v-col>


                    </v-row>

                    <div v-if="formType == '1'">
                        <h2 class="mt-10">הקריטריונים לקבלת הסיוע:</h2>
                        <p>1. המבקש/ת משלם/ת דמי חבר או דמי טיפול במשך 3 שנים לפחות ברציפות במועד הגשת הבקשה.</p>
                        <!--below18 -->
                        <p>2. למבקש/ת ילדים מתחת לגיל 18.</p>
                        <v-row>

                            <div class="d-flex">
                                <v-checkbox
                                    class="mt-1 ml-2"
                                    v-model="below18"
                                    name="below18"
                                    value="1"
                                    :rules="[(v) => !!v || 'סעיף חובה']"
                                    label="כן"
                                ></v-checkbox>
                                <v-checkbox
                                    class="mt-1"
                                    v-model="below18"
                                    name="below18"
                                    value="-1"
                                    label="לא"
                                ></v-checkbox>
                            </div>
                        </v-row>

                        <!-- Parent Type -->
                        <p>3. המבקש/ת עומד/ת בתנאים הבאים:</p>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <p>
                                    חובה למלא סוג הורות
                                </p>
                                <v-radio-group
                                    name="parentStatus"
                                    :rules="[rules.requiredRule]"
                                    v-model="parentStatus"
                                >
                                    <v-radio value="Independent">
                                        <template v-slot:label>
                                            <div>
                                                מבקש/ת שהינו הורה יחידני/ת וסך ההכנסות החודשיות ברוטו לרבות שכר עבודה ברוטו, קצבאות של המבקש, הבטחת הכנסה, דמי אבטלה, דמי לידה, מזונות ילדים וכו', בשלושת החודשים שקדמו להגשת הבקשה לא עולה על הסכומים המצוינים מטה.
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Has_Spouse">
                                        <template v-slot:label>
                                            מבקש/ת ובן/בת זוג שסך ההכנסות החודשיות ברוטו לרבות שכר עבודה ברוטו, קצבאות של המבקש ו/או בן/בת הזוג, הבטחת הכנסה, דמי אבטלה, דמי לידה וכו', בשלושת החודשים שקדמו להגשת הבקשה לא עולה על הסכומים המצוינים מטה.
                                        </template>
                                    </v-radio>
                                    <ul v-if="true || parentStatus == 'Has_Spouse'" class="text-small text-right">
                                        <li>הורה לילד אחד מתחת לגיל 18 - 13,000 ₪ ברוטו</li>
                                        <li>הורה לשני ילדים מתחת לגיל 18 - 14,000 ₪ ברוטו</li>
                                        <li>הורה לשלושה ילדים או יותר מתחת לגיל 18 - 15,000 ₪ ברוטו</li>
                                    </ul>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Documents -->
                    <v-row v-if="formType == '2' || parentStatus" class="bg-gray">
                        <p v-if="formType == '1'">4. העלאת קבצי עובד/ת בהורות <span
                            v-if="parentStatus === 'Independent'">יחידנית</span><span
                            v-if="parentStatus === 'Has_Spouse'">זוגית</span>:</p>
                        <v-col cols="12">
                            <p>ניתן לבחור קבצים מרובים, ע"י לחיצה על המקש Ctrl בזמן בחירת הקבצים</p>
                            <p class="text-small text-cyan">{{ fileTypes }}</p>
                        </v-col>
                        <!-- ID -->
                        <v-col cols="12" sm="6">

                            <v-file-input
                                label="נא לצרף צילום ת.ז. עם ספח"
                                class="required"
                                required
                                multiple
                                append-icon="mdi-id-card"
                                prepend-icon=""
                                name="idCard"
                                v-model="idCard"
                                :outlined="outlined"
                                :rules="rules.generalFile('צילום ת.ז. עם ספח')"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.idCard" v-if="tooltip.idCard"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                label="תלוש שכר ברוטו  - בחודש אחרון שקדם להגשת הבקשה"
                                class="required"
                                required
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="monthlyIncomeFiles1[]"
                                v-model="monthlyIncomeFiles1"
                                :outlined="outlined"
                                :rules="rules.generalFile('הכנסה אחרונה')"
                                show-sizef
                            ></v-file-input>
                            <span v-tooltip="tooltip.monthlyIncomeFiles" v-if="tooltip.monthlyIncomeFiles"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                label="תלוש שכר ברוטו - בחודשיים שקדמו להגשת הבקשה"
                                class="required"
                                required
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="monthlyIncomeFiles2[]"
                                v-model="monthlyIncomeFiles2"
                                :outlined="outlined"
                                :rules="rules.generalFile('הכנסה לפני חודשיים')"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.monthlyIncomeFiles" v-if="tooltip.monthlyIncomeFiles"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                label=" תלוש שכר ברוטו - 3 חודשים שקדמו להגשת הבקשה "
                                class="required"
                                required
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="monthlyIncomeFiles3[]"
                                v-model="monthlyIncomeFiles3"
                                :outlined="outlined"
                                :rules="rules.generalFile('הכנסה לפני 3 חודשים')"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.monthlyIncomeFiles" v-if="tooltip.monthlyIncomeFiles"></span>
                        </v-col>

                        <v-col cols="12" sm="6" v-if="parentStatus === 'Independent'">
                            <v-file-input
                                multiple
                                small-chips
                                label='תצהיר הורה יחידני ממשרד העבודה - עדכני (כולל חתימת עו"ד כדין)'
                                class="required"
                                required
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="singleParentApprove[]"
                                v-model="singleParentApprove"
                                :outlined="outlined"
                                :rules="rules.generalFile('תצהיר הורה יחידני ממשרד העבודה')"
                                show-size
                            ></v-file-input>
                            <a
                                v-if="tooltip.independentFiles1 && single_parent_affidavit_example"
                                :href="single_parent_affidavit_example"
                                :aria-label="tooltip.independentFiles1"
                                class="download_file_tooltip"
                                download
                            >
                                <span v-tooltip="tooltip.independentFiles1" class="download_file_tooltip"></span>
                            </a>

                        </v-col>

                        <v-col cols="12" sm="6" v-if="parentStatus === 'Has_Spouse'">
                            <v-file-input
                                required
                                class="required"
                                multiple
                                small-chips
                                label="תלוש שכר ברוטו בן/בת זוג - בחודש אחרון  שקדם  להגשת הבקשה "
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="SpouseMonthlyIncomeFiles1[]"
                                v-model="SpouseMonthlyIncomeFiles1"
                                :outlined="outlined"
                                :rules="rules.generalFile('אסמכתאות על המוגבלות')"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.spouseFiles1" v-if="tooltip.spouseFiles1"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="parentStatus === 'Has_Spouse'">
                            <v-file-input
                                required
                                class="required"
                                multiple
                                small-chips
                                label="תלוש שכר ברוטו בן/ בת זוג - בחודשיים שקדמו להגשת הבקשה "
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="SpouseMonthlyIncomeFiles2[]"
                                v-model="SpouseMonthlyIncomeFiles2"
                                :outlined="outlined"
                                :rules="rules.generalFile('אסמכתאות על המוגבלות')"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.spouseFiles2" v-if="tooltip.spouseFiles2"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="parentStatus === 'Has_Spouse'">
                            <v-file-input
                                required
                                class="required"
                                multiple
                                small-chips
                                label="תלוש שכר ברוטו בן/בת זוג - 3 חודשים שקדמו להגשת הבקשה "
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="SpouseMonthlyIncomeFiles3[]"
                                v-model="SpouseMonthlyIncomeFiles3"
                                :outlined="outlined"
                                :rules="rules.generalFile('אסמכתאות על המוגבלות')"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.spouseFiles3" v-if="tooltip.spouseFiles3"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="parentStatus === 'Has_Spouse'">
                            <v-file-input
                                multiple
                                small-chips
                                label='אישור מעמד לא עובד מביטוח לאומי עבור בן/בת הזוג - עדכני'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="spouseBtl[]"
                                v-model="spouseBtl"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור מעמד לא עובד מביטוח לאומי', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.spouseFiles4" v-if="tooltip.spouseFiles4"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="parentStatus === 'Has_Spouse'">
                            <v-file-input
                                multiple
                                small-chips
                                label="אישור גובה מלגת ישיבה (דתות+תרומות) לבן הזוג ל-3 החודשים האחרונים"
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="spouseYeshiva[]"
                                v-model="spouseYeshiva"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור גובה מלגת ישיבה', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.spouseFiles5" v-if="tooltip.spouseFiles5"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="parentStatus === 'Has_Spouse'">
                            <v-file-input
                                multiple
                                small-chips
                                label='אישור תשלומי קצבת נכות מב"ל עבור הפונה ו/או בן/בת הזוג – עדכני'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="spouseDisabilities[]"
                                v-model="spouseDisabilities"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור תשלומי קצבת נכות', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.spouseFiles6" v-if="tooltip.spouseFiles6"></span>
                        </v-col>


                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label="הסכם/פסק דין מלא ובו התייחסות לגובה דמי מזונות ומשמורת הילדים"
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="AlimonyApproval[]"
                                v-model="AlimonyApproval"
                                :outlined="outlined"
                                :rules="rules.generalFile('משמורת ילדים', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.independentFiles2" v-if="tooltip.independentFiles2"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label="אישור על תשלום מזונות/הבטחת הכנסה מביטוח לאומי"
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="AlimonyBTL[]"
                                v-model="AlimonyBTL"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור מביטוח לאומי', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.independentFiles3" v-if="tooltip.independentFiles3"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label='מי שלא מקבל/ת דמי מזונות-חוב הוצל"פ עדכני ובו פרטי הצדדים והתשלומים'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="AlimonyHozlap[]"
                                v-model="AlimonyHozlap"
                                :outlined="outlined"
                                :rules="rules.generalFile('חוב הוצאה לפועל', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.independentFiles4" v-if="tooltip.independentFiles4"></span>
                        </v-col>


                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label='מסמכים נוספים 1'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="AdditionalDocs[]"
                                v-model="AdditionalDocs"
                                :outlined="outlined"
                                :rules="rules.generalFile('מסמכים נוספים', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.AdditionalDocs" v-if="tooltip.AdditionalDocs"></span>
                        </v-col>

                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label='מסמכים נוספים 2'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="AdditionalDocs2[]"
                                v-model="AdditionalDocs2"
                                :outlined="outlined"
                                :rules="rules.generalFile('מסמכים נוספים', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.AdditionalDocs" v-if="tooltip.AdditionalDocs"></span>
                        </v-col>

                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label='אישור רו"ח/יועץ מס על גובה ההכנסות - 3 חודשים שקדמו להגשת הבקשה'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="IndependentScan[]"
                                v-model="IndependentScan"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור מס לעצמאים', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.IndependentScan" v-if="tooltip.IndependentScan"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label='הכנסות נוספות'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="additionalIncome[]"
                                v-model="additionalIncome"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור מס לעצמאים', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.additionalIncome" v-if="tooltip.additionalIncome"></span>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="formType == '1'">
                            <v-file-input
                                multiple
                                small-chips
                                label='אישור תשלומי קצבת שארים מב"ל עבור הפונה ו/או בן/בת הזוג – עדכני'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="deathBenefit[]"
                                v-model="deathBenefit"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור תשלומי קצבת שארים', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.deathBenefit" v-if="tooltip.deathBenefit"></span>
                        </v-col>

                        <v-col cols="12" sm="6" v-if="formType == '2'">
                            <v-file-input
                                multiple
                                small-chips
                                class="required"
                                required
                                label='נא לצרף אישור שורד שואה מוועדת התביעות או מהרשות לניצולי שואה'
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="SurvivorScan[]"
                                v-model="SurvivorScan"
                                :outlined="outlined"
                                :rules="rules.generalFile('אישור שורד שואה', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.SurvivorScan" v-if="tooltip.SurvivorScan"></span>
                        </v-col>

                        <v-col cols="12" v-if="parentStatus === 'Has_Spouse'">
                            <p class="text-small text-medium text-red">*שימו לב, במידה ואחד מבני הזוג אינו עובד, חובה לצרף אישור למבוטח אשר רשום במוסד לביטוח לאומי כלא עובד, סטודנט או תלמיד ישיבה וכן המשלם דמי ביטוח מינימליים.</p>
                        </v-col>
                    </v-row>

                    <!-- Disability Statement -->
                    <h2 class="mt-10" v-if="formType == '1'">הצהרת מוגבלויות</h2>
                    <v-row v-if="formType == '1'">
                        <v-col cols="12" sm="12">
                            <p>
                                במידה ולך ו/או לבן/בת זוגך ישנן מוגבלויות אנא העלה את המסמכים הנדרשים.<br/>
                                * במידה והנך מקבל/ת קצבה בגין המוגבלויות – חובה יהיה לצרף אותה במסמכים הנדרשים בהמשך הבקשה.
                            </p>
                            <p class="text-small text-cyan">{{ fileTypes }}</p>

                        </v-col>
                        <v-col cols="12" md="6">
                            <v-file-input
                                multiple
                                small-chips
                                label="אסמכתאות על המוגבלות"
                                append-icon="mdi-paperclip"
                                prepend-icon=""
                                name="disabilityApproval[]"
                                v-model="disabilityApproval"
                                :outlined="outlined"
                                :rules="rules.generalFile('אסמכתאות', false)"
                                show-size
                            ></v-file-input>
                            <span v-tooltip="tooltip.disability" v-if="tooltip.disability"></span>
                        </v-col>
                    </v-row>


                </v-col>
            </v-row>

            <!-- General Details -->
            <v-row>
                <v-col cols="12" md="6">
                    <p>הערות – נא לפרט את סיבת הבקשה ו/או צרכים מיוחדים במידה וישנם.</p>
                    <v-textarea
                        label="סיבת הגשת הבקשה"
                        v-model.trim="reason"
                        name="reason"
                        :counter="500"
                        :outlined="outlined"

                    ></v-textarea>
                    <ul class="text-small text-right">
                        <li>כל המוצרים בסלים המונפקים כשרים למהדרין למעט בחג הפסח בו המוצרים בכשרות רבנות בלבד.</li>
                    </ul>
                </v-col>
            </v-row>

            <v-divider/>

            <!-- Approve -->
            <v-row v-if="formType == '1'">
                <v-col cols="12" lg="6">
                    <v-checkbox
                        class="mt-5"
                        v-model="approve"
                        name="approve"
                        value="1"
                        :rules="[(v) => !!v || 'סעיף חובה']"
                        label="הנני מאשר/ת כי ידוע לי שתנאי סף להגשת הבקשה הוא תשלום דמי חבר או דמי טיפול להסתדרות במשך 36 חודשים רצופים לפני מועד הגשת הבקשה וכי הפרטים שמילאתי בטופס זה הינם נכונים, מלאים ומדויקים."
                    ></v-checkbox>
                </v-col>
            </v-row>

            <v-row class="mt-0" v-if="formType == '1'">
                <v-col cols="12" lg="6" class="pt-0">
                    <v-checkbox
                        v-model="declare"
                        name="declare"
                        value="1"
                        :rules="[(v) => !!v || 'סעיף חובה']"
                        label="הנני מצהיר כי אין לי ו/או לבן/בת זוגי הכנסות נוספות שלא דיווחתי עליהם במסגרת בקשה זו."
                    ></v-checkbox>
                </v-col>
            </v-row>

            <!-- Submit -->
            <div class="text-center text-sm-right">
                <p class="d-block font-weight-bold mb-0">*הבקשה תיבדק ותטופל תוך 21 יום</p>
                <p class="d-block font-weight-bold mb-0">לשאלות ובירורים נוספים אנא פנה/י למוקד המידע והשירות של ההסתדרות בטלפון 2383*</p>
                <v-btn
                    :loading="loading"
                    class="mt-3 mb-10"
                    type="submit"
                    color="primary"
                    large
                >הגשת הבקשה
                </v-btn>
            </div>

        </v-form>
        <!-- Success message -->
        <v-col cols="12" sm="4" offset="4" v-if="step == 'sent'" type="success" class="mt-10 text-center">
            <img src="../assets/file.svg">
            <h2 class="text-center">הבקשה נקלטה בהצלחה</h2>
            <p class="text-center">תודה על פנייתך,<br>
                הבקשה נקלטה בהצלחה
                והיא תיבדק ותטופל תוך 21 יום ממועד קבלתה<br>
                לשאלות ובירורים נוספים אנא פנה/י למוקד המידע והשירות של ההסתדרות בטלפון 2383*
            </p>
            <p class="text-center text-cyan">
                ההסתדרות תמשיך לפעול בכל האמצעים העומדים לרשותה
                לחיזוק מעמד האדם העובד ולטיפוח חברה שוויונית והוגנת יותר.
            </p>
            <v-row class="text-center">
                <v-btn
                    color="primary"
                    @click="step='identify'"

                >חזרה לדף הבית
                </v-btn>
            </v-row>
        </v-col>
        <!-- Process Error Message -->
        <v-col cols="12" sm="4" offset="4" v-if="step == 'process'" type="error" class="mt-10 text-center">
            <img src="../assets/alert.svg">
            <h2 class="text-center text-red">בקשה בתהליך</h2>
            <p class="text-center"
            >מצטערים,<br>
                לא ניתן לפתוח בקשה כיוון שכבר קיימת בקשה בתהליך</p
            >
            <v-row class="text-center">
                <v-btn
                    color="primary"
                    @click="step='identify'"

                >חזרה לדף הבית
                </v-btn>
            </v-row>
        </v-col>
    </v-container>
</template>
<script>
import * as rules from "@/rules";
import * as selectsItems from "@/selects-items";
import Config from "@/config";
import onResize from "@/iframe-height-update";

export default {
    name : "Form",
    data() {
        return {
            step : 'identify', // options: identify, auth, apply, process, sent
            identifyBy : 'id', // options: id, passport
            verifyCodeTo : 'mobile', // options: mobile, email
            auth : 'pending', // options: pending, success, error
            formType : '1', // 1: regular form, 2: survivors
            rules : rules,
            selects : selectsItems,
            fieldsStatus : false,
            smsStatus : false,
            loading : false,
            confirmDialog : false,
            outlined : true,
            dialog : false,
            dialogText : "",
            cities : [],
            streets : [],
            workStreets : [],
            workPlaces : [],
            loadingCities : false,
            loadingStreets : false,
            loadingworkStreets : false,
            loadingPlaces : false,
            firstPoppedAlert : false,
            authCode : "",
            encoded : "",
            tooltip : {},
            fileTypes : 'ניתן להעלות קבצים מסוג pdf, doc, docx, png, jpeg, jpg ועד גודל של 5Mb',
            below18 : '0',

            single_parent_affidavit_example: Config.single_parent_affidavit ? Config.download_path + Config.single_parent_affidavit : null,

            // fields:
            id : "",
            passport : "",
            firstName : "",
            lastName : "",
            tel : "",
            parentStatus : "",
            email : "",
            city : "",
            street : "",
            homeNum : "",
            apartNum : "",
            apartEntrance : "",
            apartFloor : "",
            reason : "",
            approve : "",
            declare : "",
            helperName : "",
            helperPhone : "",
            helperEmail : "",
            houseType : "sharedHouse",

            // Files :
            idCard : null,
            monthlyIncomeFiles1 : null,
            monthlyIncomeFiles2 : null,
            monthlyIncomeFiles3 : null,
            SpouseMonthlyIncomeFiles1 : null,
            SpouseMonthlyIncomeFiles2 : null,
            SpouseMonthlyIncomeFiles3 : null,
            spouseBtl : null,
            spouseYeshiva : null,
            spouseDisabilities : null,
            singleParentApprove : null,
            AlimonyApproval : null,
            AlimonyBTL : null,
            AlimonyHozlap : null,
            disabilityApproval : null,
            AdditionalDocs : null,
            AdditionalDocs2 : null,
            IndependentScan : null,
            SurvivorScan : null,
            additionalIncome : null,
            deathBenefit : null,

        };
    },
    methods : {
        cityChanged( cityCode, target ) {
            this[ target ] = null;
            if ( cityCode !== null ) {
                this[ "loading" + target + "s" ] = true;
                this.axios
                    .get( Config.api_ajax + "?action=getApiStreets&city=" + cityCode )
                    .then( ( response ) => {
                        this[ target + "s" ] = response.data;
                    } )
                    .finally( () => {
                        this[ "loading" + target + "s" ] = true;
                    } );
            }
        },
        checkSMS() {
            if ( !this.smsStatus ) {
                // try to focus on first invalid input
                let first_field = document.querySelector( ".v-input.error--text" );
                if ( first_field ) {
                    first_field = first_field.querySelector( "input, select, textarea" );
                    if ( first_field ) {
                        first_field.focus();
                    }
                }
            } else {
                this.sendSMS();
            }
        },
        sendSMS() {
            this.unset();
            let form = new FormData( this.$refs.formsms.$el );
            form.append( "verify", this.verifyCodeTo );
            form.append( "email", this.email );
            form.append( "phone", this.tel );

            this.axios
                .post( Config.api_ajax + "?action=sms", form )
                .then( ( response ) => {
                    let data = response.data;
                    if ( data && data !== 'error' ) {
                        this.encoded = data;
                        this.step = 'auth';
                    }
                } )
                .catch( ( e ) =>
                    window.parent.alert(
                        "אופס... התרחשה שגיאה, נסו שוב במועד מאוחר יותר." + "[" + e + "]"
                    )
                )
                .finally( () => {
                    this.loading = false;
                    this.$nextTick( () => {
                        onResize();
                    } );
                } );
            // this.step = 'auth';
        },
        unset() {
            // this.axios.post( Config.api_ajax + "?action=unset" );
            this.auth = 'pending';
        },
        resend() {
            this.unset();
            let form = new FormData( this.$refs.formauth.$el );
            form.append( "verify", this.verifyCodeTo );
            form.append( "email", this.email );
            form.append( "phone", this.tel );
            this.axios
                .post( Config.api_ajax + "?action=sms", form )
                .then( ( response ) => {
                    let data = response.data;
                    if ( data && data !== 'error' ) {
                        this.encoded = data;
                        this.step = 'auth';
                    }
                } )
                .catch( ( e ) =>
                    window.parent.alert(
                        "אופס... התרחשה שגיאה, נסו שוב במועד מאוחר יותר." + "[" + e + "]"
                    )
                )
                .finally( () => {
                    this.loading = false;
                    this.$nextTick( () => {
                        onResize();
                    } );
                } );
        },
        authenticate() {
            if ( process.env.NODE_ENV !== 'production' ) {
                if ( this.authCode == '12345' ) {
                    this.checkStatus();
                    return;
                }
                if ( this.authCode == 'success' ) {
                    this.step = 'apply';
                    return;
                }
                if ( this.authCode == 'error' ) {
                    this.step = 'process';
                    return;
                }
            }
            this.auth = 'pending';
            let form = new FormData( this.$refs.formauth.$el );
            form.append( "confirmCode", this.authCode );
            this.axios
                .post( Config.api_ajax + "?action=smsconfirm", form )
                .then( ( response ) => {
                    let data = response.data;
                    if ( data && !data.startsWith( 'error' ) ) {
                        this.auth = 'success';
                        this.checkStatus();
                    } else {
                        this.auth = 'error';
                    }
                } )
                .catch( ( e ) =>
                    window.parent.alert(
                        "אופס... התרחשה שגיאה, נסו שוב במועד מאוחר יותר." + "[" + e + "]"
                    )
                )
                .finally( () => {
                    this.loading = false;
                    this.$nextTick( () => {
                        onResize();
                    } );
                } );
        },
        checkStatus() {
            let form = new FormData( this.$refs.formauth.$el );
            form.append( "id", this.id );
            form.append( "passport", this.passport );
            form.append( "identifyBy", this.identifyBy );
            this.axios
                .post( Config.api_ajax + "?action=checkStatus", form )
                .then( ( response ) => {
                    let data = response.data;

                    /**
                     * Just for debugging
                     */
                    // if( this.id === '123456782' ) { // This is a demo ID card number
                    //     this.step = 'process';
                    //     return
                    // }

                    if ( data && data === 'success' ) {
                        this.step = 'apply';
                    } else {
                        this.step = 'process';
                    }
                } )
                .catch( ( e ) =>
                    window.parent.alert(
                        "אופס... התרחשה שגיאה, נסו שוב במועד מאוחר יותר." + "[" + e + "]"
                    )
                )
                .finally( () => {
                    this.loading = false;
                    this.$nextTick( () => {
                        onResize();
                    } );
                } );
        },
        submit() {
            this.$refs.formapp.validate();
            this.$nextTick( () => {
                if ( !this.fieldsStatus ) {
                    // try to focus on first invalid input
                    let first_field = document.querySelector( ".v-input.error--text" );
                    if ( first_field ) {
                        first_field = first_field.querySelector( "input, select, textarea" );
                        if ( first_field ) {
                            first_field.focus();
                        }
                    }
                } else {
                    if ( window.parent.confirm( "יש לעבור ולוודא את תקינות המידע שהוזן בטופס, כמו כן גם שצורפו כל הקבצים הרלוונטיים." + "\n" + "האם לשלוח את הטופס?" ) ) {
                        this.sendForm();
                    }
                }
            } );
        },
        sendForm() {
            this.confirmDialog = false;
            this.loading = true;
            // Collect data to send
            let form = new FormData( this.$refs.formapp.$el );
            form.append( "id", this.id );
            form.append( "passport", this.passport );
            form.append( "email", this.email );
            form.append( "tel", this.tel );
            form.append( "identifyBy", this.identifyBy );
            form.append( "verifyCodeTo", this.verifyCodeTo );
            form.append( "formType", this.formType );
            this.axios
                .post( Config.api_ajax + "?action=sendAidForm", form )
                .then( ( response ) => {
                    let data = response.data;
                    if ( data && data.status ) {
                        this.step = 'sent';
                    } else {
                        window.parent.alert( data.data || "שגיאה כללית, נסו שוב מאוחר יותר" );
                        // this.dialogText = data.data || 'שגיאה כללית, נסו שוב מאוחר יותר'
                        // this.dialog = true
                    }
                } )
                .catch( ( e ) =>
                    window.parent.alert(
                        "אופס... התרחשה שגיאה, נסו שוב במועד מאוחר יותר." + "[" + e + "]"
                    )
                )
                .finally( () => {
                    this.loading = false;
                    this.$nextTick( () => {
                        onResize();
                    } );
                } );
        },
        dialogPopped( state ) {
            if ( state ) {
                this.$nextTick( () => {
                    document.querySelector( ".v-dialog__content" ).scrollIntoView();
                } );
            }
        },
    },
    watch : {
        city( cityCode ) {
            this.cityChanged( cityCode, "street" );
        },
        workCity( cityCode ) {
            this.cityChanged( cityCode, "workStreet" );
        },
        identifyBy( val ) {
            if ( val === 'id' ) {
                this.passport = "";
            } else {
                this.id = "";
            }
        },
        below18( val ) {
            if ( val === "-1" ) {
                alert( "ילדים מתחת לגיל 18 זהו תנאי חובה להגשת הבקשה." );
                this.below18 = '';
            }
        },
    },
    beforeMount() {

        // get form_type
        const urlParams = new URLSearchParams( window.location.search );
        this.formType = urlParams.get( "type" ) || 1;

        // cities
        this.axios
            .get( Config.api_ajax + "?action=getApiCities" )
            .then( ( response ) => {
                this.cities = response.data;
            } )
            .finally( () => {
                this.loadingCities = false;
            } );
        // work places
        this.axios
            .get( Config.api_ajax + "?action=getApiWorkPlaces" )
            .then( ( response ) => {
                this.workPlaces = response.data;
            } )
            .finally( () => {
                this.loadingPlaces = false;
            } );
        this.tooltip.idCard = '';
        this.tooltip.monthlyIncomeFiles = 'יש לצרף אישור על הכנסות ברוטו בשלושת החודשים האחרונים. טפסים אלו יכולים להיות :<br><br>הכנסות שכר עבודה/ עסק (למשל : מכתב עדכני מרו"ח, דוח רווח והפסד שנתי)/דמי אבטלה / הבטחת הכנסה';
        this.tooltip.disability = '';
        this.tooltip.spouseFiles1 = 'יש לצרף אישור על הכנסות ברוטו בן/בת הזוג 3 חודשים אחרונים. טפסים אלו יכולים להיות :<br><br>הכנסות שכר עבודה/ עסק (למשל : מכתב עדכני מרו"ח, דוח רווח והפסד שנתי) /דמי אבטלה / הבטחת הכנסה';
        this.tooltip.spouseFiles2 = 'יש לצרף אישור על הכנסות ברוטו בן/בת הזוג 3 חודשים אחרונים. טפסים אלו יכולים להיות :<br><br>הכנסות שכר עבודה/ עסק (למשל : מכתב עדכני מרו"ח, דוח רווח והפסד שנתי) /דמי אבטלה / הבטחת הכנסה';
        this.tooltip.spouseFiles3 = 'יש לצרף אישור על הכנסות ברוטו בן/בת הזוג 3 חודשים אחרונים. טפסים אלו יכולים להיות :<br><br>הכנסות שכר עבודה/ עסק (למשל : מכתב עדכני מרו"ח, דוח רווח והפסד שנתי) /דמי אבטלה / הבטחת הכנסה';
        this.tooltip.spouseFiles4 = null;
        this.tooltip.spouseFiles5 = 'אישור לימודים חתום על ידי המוסד התורני, המפרט את פרטי התלמיד ואת תקופת הלימודים וכולל הכנסה מדתות+תרומות';
        this.tooltip.spouseFiles6 = null;
        this.tooltip.spouseFiles7 = 'יש לצרף פירוט תנועות חשבון בנק חצי שנה אחרונה במידה ואין פס"ד בתוקף';
        this.tooltip.spouseFiles8 = '';
        this.tooltip.spouseFiles9 = '';

        this.tooltip.independentFiles1 = 'לחצו להורדת קובץ דוגמא למילוי והדפסה';
        this.tooltip.independentFiles2 = 'במידה ויש נספחים מעודכנים להסכם יש לצרפם';
        this.tooltip.independentFiles3 = 'עבור 3 החודשים שקדמו להגשת הבקשה';
        this.tooltip.independentFiles4 = 'פירוט תיק הוצל"פ עבור 6 חודשים אחרונים כולל פרטי הצדדים ופירוט התשלומים';
        this.tooltip.AdditionalDocs = '';
        this.tooltip.IndependentScan = 'כולל הצהרת רו"ח/יועץ מס כי הפונה ו/או בן זוגו אינם מקבלים משכורת מהעסק';
        this.tooltip.SurvivorScan = 'נא לצרף אישור שורד שואה - מועדת התביעות או מהרשות לזכויות שורדי שואה';
        this.tooltip.additionalIncome = 'שכר מעבודה נוספת/דמי אבטלה 3 חודשים אחרונים/ הבטחת הכנסה 3 חודשים אחרונים/אישור על תקופת שמירת הריון /אישור דמי לידה מביטוח לאומי.';
        this.tooltip.deathBenefit = 'עדכני מ- 30 הימים שקדמו להגשת הבקשה';
    },
};
</script>
<style lang="scss">

h1 {
    font-family: "liddar", sans-serif;
    font-weight: 500 !important;
    line-height: 1;
    font-size: 45px;
    @media (min-width: 600px) {
        font-size: 55px;
    }
}

.small-label {
    line-height: 1;

    p {
        font-size: 16px;
        display: flex;
    }

    .asterik {
        color: black;
        margin-top: 4px;
        margin-left: 4px;
        font-size: 16px;
    }
}

h2 {
    font-size: 27px;
}

h1,
h2,
h3 {
    color: #0167b1;
}

.required .v-label {
    padding-right: 15px;

    &:before {
        content: "*";
        color: #E0272A;
        font-size: 30px;
        position: absolute;
        top: 2px;
        right: 0;
    }
}

ol,
ul {
    width: 100%;
    overflow: hidden;
    padding: 0 30px 0 0 !important;
    margin: 0 !important;

    li {
        margin-right: 0;
        padding-right: 0;
    }
}

p {
    font-size: 18px;

    small {
        color: #aaa;
        font-size: 14px;
    }
}

.overflow-hidden {
    overflow: hidden;
}

.minus-top {
    margin-top: -20px;
}

.v-input--radio-group__input {
    legend {
        position: static !important;
        font-size: 18px !important;
        color: black !important;
        text-align: right !important;
        height: auto !important;
        line-height: 1.5 !important;
        margin-bottom: 16px;
    }
}

.v-input--checkbox .v-label {
    font-weight: 600;
    font-size: 18px;
}

.v-input--selection-controls .v-label {
    left: auto !important;
    right: 0 !important;
    text-align: right !important;
}

.row > div {
    position: relative;
}

.text-center {
    justify-content: center;
}

.text-red {
    color: #E0272A;
}

.text-cyan {
    color: #00A4D9;
}

.text-small {
    font-size: 14px;
}

.text-medium {
    font-size: 18px;
}

.text-large {
    font-size: 22px;
}

.star-notice {
    top: 30px;
}

.bg-gray {
    background: #eee;
}

.v-input.v-text-field--outlined > .v-input__control > .v-input__slot {
    background-color: #fff;
}

.has-tooltip {
    background-color: #fff;
    background-image: url(../assets/question.svg);
    border-radius: 100%;
    background-size: contain;
    width: 25px;
    height: 25px;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    &.download_file_tooltip {
        background-image: url(../assets/download.svg);
    }
}

.tooltip {
    font-family: "Assistant", sans-serif;
    background: #fff;
    border: 2px solid #0390cb;
    max-width: 400px;
    text-align: center;
    padding: 10px;
    font-size: 16px;
    color: #999;
    font-weight: 600;
    margin-bottom: 20px;

    &:before {
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 17.3px 10px 0 10px;
        border-color: #0390cb transparent transparent transparent;
        bottom: -18px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;
    }

    &:after {
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 17.3px 10px 0 10px;
        border-color: #fff transparent transparent transparent;
        bottom: -15px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;
    }
}

.vertical-radio {
    &.v-input--radio-group--column {
        .v-input--radio-group__input {
            flex-direction: row;
            justify-content: space-around;
        }

        .v-radio:not(:last-child):not(:only-child) {
            margin: 0;
        }
    }
}

.house-type {
    .house-type-radio-group {
        color: rgba(0, 0, 0, 53%);

        .house-type-title {
            color: inherit;
            margin-bottom: 3px;
        }

        [role="radiogroup"] {
            width: fit-content;
            padding: 8px 15px;
            border: 1px solid currentColor;
            border-radius: 4px;
            border-collapse: collapse;
        }
    }
}

</style>